export default __webpack_public_path__ + "static/media/frame6.436a949e.jpg";